"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class App {
    constructor(components = {}) {
        this.loaders = new Map();
        this.components = new Map();
        this.eventStore = App.createEventStore();
        this.context = {
            app: this,
            dispatchEvent: this.eventStore.dispatch,
            useEventHistory: this.eventStore.history,
        };
        this.add(components);
    }
    static createEventStore() {
        const list = new Array();
        return {
            list,
            dispatch: (type, payload) => {
                list.push([type.toString(), payload]);
                document.dispatchEvent(new CustomEvent(type.toString(), { detail: payload }));
            },
            history: (fn, filter) => {
                const events = filter
                    ? list.filter(([event]) => Array.isArray(filter) ? filter.includes(event) : filter === event)
                    : list;
                fn(events);
            },
        };
    }
    static createHook() {
        const list = new Array();
        return {
            list,
            addListener(fn) {
                list.push(fn);
            },
            run() {
                list.forEach((fn) => fn());
            },
        };
    }
    getComponentContext({ mounted, triggered }) {
        return Object.assign(Object.assign({}, this.context), { onTriggered: triggered.addListener, onMounted: mounted.addListener });
    }
    createComponent(element, args) {
        const mounted = App.createHook();
        const triggered = App.createHook();
        const context = this.getComponentContext({ mounted, triggered });
        this.components.set(element, 'created');
        if (Array.isArray(args)) {
            const events = Array.isArray(args[0]) ? args[0] : [args[0]];
            const component = args[1];
            const mountComponent = () => __awaiter(this, void 0, void 0, function* () {
                if (this.components.get(element) === 'created') {
                    (yield component()).default(element, context);
                    this.components.set(element, 'mounted');
                    mounted.run();
                }
                triggered.run();
            });
            const executeCustomLoader = (event) => {
                if (typeof event === 'function') {
                    event(Object.assign({ node: element }, context), mountComponent);
                }
                else {
                    element.addEventListener(event, mountComponent);
                }
            };
            events.forEach(executeCustomLoader);
        }
        else {
            args(element, context);
            this.components.set(element, 'mounted');
            mounted.run();
            triggered.run();
        }
    }
    add(components = {}) {
        Object.keys(components).forEach((key) => {
            const component = components[key];
            if (component) {
                this.loaders.set(key, component);
            }
        });
    }
    mount(root = document) {
        const elements = root.querySelectorAll('[data-component]');
        elements.forEach((element) => __awaiter(this, void 0, void 0, function* () {
            // Check if component is already mounted
            if (this.components.has(element)) {
                return;
            }
            // Check if loader exists
            const loader = this.loaders.get(element.dataset.component);
            if (!loader) {
                return;
            }
            this.createComponent(element, loader);
        }));
    }
}
exports.default = App;
//# sourceMappingURL=app.js.map